import { render, staticRenderFns } from "./PowerTelegramMain.vue?vue&type=template&id=71a72e58&scoped=true"
import script from "./PowerTelegramMain.vue?vue&type=script&lang=js"
export * from "./PowerTelegramMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a72e58",
  null
  
)

export default component.exports